import fetch from '@adc/fetch'
import configment from '@adc/configment'

export const getSellerCodes = async (req, searchVal) => {
  const res = await fetch(
    `${configment.get('RESI_MS_SELLER')}/resi/seller/v1/seller-plans`,
    {
      req,
      queryParams: {
        search_term: searchVal,
      },
    }
  )
  return res.body
}
